<mat-spinner *ngIf="loadingPage"></mat-spinner>
<form *ngIf="!loadingPage" [formGroup]="addressForm" class="p-3">
    <div class="form-row">
        <div class="form-group col-md-6">
            <mat-form-field  appearance="outline">
                <mat-label>First Name</mat-label> 
                <input matInput type="text" class="form-control" [formControl]="form.firstname" [errorStateMatcher]="matcher" id="firstname" aria-describedby="emailHelp" placeholder="Enter first name / ex: Fontaine">
                <mat-hint>Enter first name / ex: Jean-Michel</mat-hint>
                <mat-error *ngIf="form.firstname.hasError('required')">
                    <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="form.firstname.hasError('minlength')">
                    <strong>Must be at least 8 characters long</strong>
                </mat-error>
                <mat-error *ngIf="form.firstname.hasError('maxlength')">
                    <strong>Must have at least 8 characters</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-group col-md-6">
            <mat-form-field  appearance="outline">
                <mat-label>Last Name</mat-label> 
                <input matInput type="text" class="form-control" [formControl]="form.lastname" [errorStateMatcher]="matcher" id="lastname" aria-describedby="emailHelp" placeholder="Enter last name / ex: Fontaine">
                <mat-hint>Enter last name / ex: Fontaine</mat-hint>
                <mat-error *ngIf="form.lastname.hasError('required')">
                    <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="form.lastname.hasError('minlength')">
                    <strong>Must be at least 8 characters long</strong>
                </mat-error>
                <mat-error *ngIf="form.lastname.hasError('maxlength')">
                    <strong>Must have at least 8 characters</strong>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="form">
        <div class="form-group">
            <mat-form-field appearance="outline">
                <mat-label>Address</mat-label> 
                <input matInput type="text" class="form-control" [formControl]="form.address" [errorStateMatcher]="matcher" id="address" placeholder="Enter last name / ex: Fontaine">
                <mat-hint>Enter last name / ex: Fontaine</mat-hint>
                <mat-error *ngIf="form.address.hasError('required')">
                    <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="form.address.hasError('minlength')">
                    <strong>Must be at least 8 characters long</strong>
                </mat-error>
                <mat-error *ngIf="form.address.hasError('maxlength')">
                    <strong>Must have at least 8 characters</strong>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-6">
            <div class="form-group">
                <mat-form-field appearance="outline">
                    <mat-label>Country</mat-label>
                    <mat-select class="form-group" [formControl]="form.country">
                      <mat-option *ngFor="let c of countrys" [value]="c" >{{ c }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="form-group col-md-3">
            <mat-form-field appearance="outline">
                <mat-label>Province</mat-label>
                <mat-select class="form-group" [formControl]="form.province">
                  <mat-option *ngFor="let p of provincesDisplayed" [value]="p">{{ p }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="form-group col-md-3">
            <mat-form-field  appearance="outline">
                <mat-label>Postal Code</mat-label> 
                <input matInput type="text" class="form-control" [formControl]="form.postalcode" [errorStateMatcher]="matcher" id="postalcode" placeholder="Enter postal code">
                <mat-hint>Enter city / ex: Fontaine</mat-hint>
                <mat-error *ngIf="form.postalcode.hasError('required')">
                    <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="form.postalcode.hasError('minlength')">
                    <strong>Must be at least 8 characters long</strong>
                </mat-error>
                <mat-error *ngIf="form.postalcode.hasError('maxlength')">
                    <strong>Must have at least 8 characters</strong>
                </mat-error>
            </mat-form-field>
         </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-6">
            <mat-form-field  appearance="outline">
                <mat-label>City</mat-label> 
                <input matInput type="text" class="form-control" [formControl]="form.city" [errorStateMatcher]="matcher" id="city" placeholder="Enter city / ex: Croissant City">
                <mat-hint>Enter city / ex: Washington</mat-hint>
                <mat-error *ngIf="form.city.hasError('required')">
                    <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="form.city.hasError('minlength')">
                    <strong>Must be at least 8 characters long</strong>
                </mat-error>
                <mat-error *ngIf="form.city.hasError('maxlength')">
                    <strong>Must have at least 8 characters</strong>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="d-flex flex-row-reverse">
        <div>
            <button mat-raised-button type="submit" color="accent" (click)="saveAddress()">Confirm</button>
            <mat-icon *ngIf='saveSuccess'>check</mat-icon>
            <mat-icon *ngIf='saveError'>error</mat-icon>
            <span  *ngIf='formError'> Warning: Please check the form carefully for errors!</span>
            <mat-spinner diameter="30" *ngIf='loading'></mat-spinner>
        </div>
    </div>
</form>